
export class FileUtils
{
    public static GetFileNameWithoutExtension(fileName: string): string
    {
        return fileName.split(".")[0];
    }
}
